<app-navbar [planName]="planName$ | async"></app-navbar>

<div class="app-content">
    <router-outlet></router-outlet>
</div>
